import { Component } from '@angular/core';
import { ModalController,NavController, Platform, NavParams, ViewController } from 'ionic-angular';
import { datos } from '../../providers/datos';
import { Detalle } from '../detalle/detalle';
import moment from 'moment';




declare var cordova:any;
declare var document:any;
declare var window:any;
declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'tarjetas',
  templateUrl: 'tarjetas.html',
})
export class tarjetas {

menu="hoy";
hora:any;
fecha:any;
item= {
"id":"",
"nombre":"",
"cantidad":1,
"valor":0,
"fecha":"",
"hora":"",
"img":"assets/images/servicios/manos.jpg",
"des":"sasasasasas"
};

  constructor(   
   public viewCtrl: ViewController,
   public params: NavParams,
   private datos:datos,

    public modalCtrl: ModalController,
    public navParams: NavParams,
    public navCtrl: NavController
  



   ) {

  //  let temp =   this.navParams.get('item');
    // this.producto= this.params.get('producto');
    //  this.item= temp;
      
    //  console.log( temp);

  }

  ionViewDidLoad() {
    // var _hora = moment(hora,'HH:mm').locale('es');
    // var actual = moment(moment().format('HH:mm:ss'),'HH:mm').locale('es');


    this.hora = String(moment().format('HH:mm'));
    this.fecha = String(moment().format('YYYY-MM-DD'));

    console.log(this.fecha);
    // let dif = _hora.diff(actual,'minutes');

    this.item.hora=String(this.hora);
    this.item.fecha=String(this.fecha);


  }


  detalle() {

    setTimeout(() => {
      this.cancel();
    }, 50);


    
    console.log("detalle");

  
    
      this.navCtrl.push(Detalle,{ });
      
   


    // let modal = this.modalCtrl.create(Detalle,{},{cssClass: "detalle"});
    // modal.onDidDismiss(data => {
  
    //   if (data.dato) {
        
    //      }
    //      console.log(JSON.stringify(data));
    //    });
    // modal.present();
  
  }




  add(){
    let fecha = new Date()
    var _hora = moment(this.item.hora,'HH:mm').locale('es');
    var actual = moment(moment().format('HH:mm:ss'),'HH:mm').locale('es');
    let dif = _hora.diff(actual,'minutes');

// SI LA CITA ES HOY
    if(this.menu=="hoy"){
      console.log("cita para hoy");
      // this.item.fecha=String(fecha);
         
      // SI ES HOY PERO NO ES SUPERIOR AL MINIMO D ESPERA
        if (dif < this.datos.config.min_dia) {
          console.log("fuera del reglamento");
          this.datos.Toast("¡Debe ser mayor a "+this.datos.config.min_dia+" minutos desde la hora actual! ",2000);
          
        }
        else { 
          this.datos.pedido.fecha = this.item.fecha;
          this.datos.pedido.hora = this.item.hora;
            this.cancel();

          // this.datos.pedido.items.push(this.item);
          //  this.detalle();
        }
      }
// SI LA CITA ES POSFECHA

 if(this.menu=="despues"){
      console.log("cita para despues");
      
      var fecha2 = moment(this.item.fecha);
      let dif_dias = fecha2.diff(this.fecha, 'days');
      console.log(dif_dias);
      if (dif_dias<1) {
        this.datos.Toast("¡Fecha no permitida!",2000);
        
      }
      else {
        // this.datos.pedido.items.push(this.item);
        // this.detalle();
        this.datos.pedido.fecha = this.item.fecha;
          this.datos.pedido.hora = this.item.hora;
            this.cancel();
        

      }

    }






  }

  dismiss(){
    this.viewCtrl.dismiss();

  }

cancel(){
  
    this.viewCtrl.dismiss({dato:0});

}





}


// WEBPACK FOOTER //
// ./src/pages/tarjetas/tarjetas.ts